import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DatafoxDevice, TerminalStatus } from '../../../models/datafox-device.model';
import { Shop } from '../../../models/shop.model';
import { ComponentCanDeactivate } from '../../../services/component-can-deactivate';
import { ShopService } from '../../../services/shop.service';
import { TerminalsService } from '../../../services/terminals.service';

@Component({
    selector: 'terminal',
    templateUrl: './terminal.component.html',
    styleUrls: ['./terminal.component.css'],
    standalone: false
})
export class TerminalComponent extends ComponentCanDeactivate implements AfterViewInit, OnDestroy, OnInit {

  /* Validation */
  @ViewChild("form", { static: false }) public form: NgForm;

  public fetchedTerminal: DatafoxDevice;
  private terminalsChangedSubscription: Subscription;
  public myControl = new FormControl();
  public filteredDeviceTypes: Observable<string[]>;

  constructor(private activeRoute: ActivatedRoute, private terminalsService: TerminalsService,
    private shopService: ShopService) {
    super();

    /* get resolved terminal by subscription */
    this.activeRoute.parent.data.subscribe(data => {
      this.fetchedTerminal = data.terminal;
      if (this.fetchedTerminal) {
        this.updateFilteredDeviceTypes();
        this.terminalsService.selectTerminal(this.fetchedTerminal);
      } else {
        //console.error("Prefetching did not work or is disabled.");
      }
    });

    this.terminalsChangedSubscription = this.terminalsService.allTerminalsChanged.subscribe(terminals => {
      if (terminals?.length > 0) {
        let selectedTerminal = this.terminalsService.getSelectedModel();
        if (selectedTerminal?.serialNumber && selectedTerminal?.deviceType) {
          let find = terminals.find(x => x.deviceType == selectedTerminal.deviceType && x.serialNumber == selectedTerminal.serialNumber);
          if (find && find.status != selectedTerminal.status) {
            //console.log('Status des ausgewählten Terminals hat sich geändert => aktualisiert ###');
            // Status hat sich geändert => ausgewähltes Terminal Status updaten
            // bei allen ändern, damit das Status flag nicht dafür sorgt, dass es als Änderung zum Speichern erkannt wird
            selectedTerminal.status = find.status;
            terminalsService.editedModel.status = find.status;
            terminalsService.getOldModel().status = find.status;
          }
        }
      }
    });
  }

  canDeactivate(): boolean {
    return !this.terminalsService.isModelChanged();
  }

  ngOnInit(): void {
    this.updateFilteredDeviceTypes();
    this.shopService.updateAllShops();
  }

  ngAfterViewInit(): void {
    this.terminalsService.addFormToValidation(this.form, 'Terminal');
  }

  ngOnDestroy(): void {
    this.terminalsService.updateFormValidation('Terminal', this.form.valid);
    this.terminalsService.setTerminal(null);
    if (this.terminalsChangedSubscription) {
      this.terminalsChangedSubscription.unsubscribe();
    }
  }

  private updateFilteredDeviceTypes() {
    this.filteredDeviceTypes = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value ? value.toLowerCase() : value;

    if (this.terminalsService.allDeviceTypes) {
      return this.terminalsService.allDeviceTypes.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
    } else {
      return this.terminalsService.allDeviceTypes;
    }
  }

  get allShops(): Shop[] {
    return this.shopService.allShops;
  }

  get terminal(): DatafoxDevice {
    return this.terminalsService.getEditedModel();
  }

  get oldTerminal(): DatafoxDevice {
    return this.terminalsService.getOldModel();
  }

  public deactivateServiceModeButton: boolean = false;
  public setServiceMode(terminal: DatafoxDevice) {
    if (terminal?.deviceType && terminal?.serialNumber) {
      // TODO Status prüfen
      this.deactivateServiceModeButton = true;
      this.terminalsService.setServiceMode(terminal).then(res => {
        this.deactivateServiceModeButton = false;
      }).catch(error => {
        this.deactivateServiceModeButton = false;
      });
    }
  }

  get isOnline(): boolean {
    return this.terminal ? this.terminal.status == TerminalStatus.Online : false;
  }

  get canEditSerialNumberAndType(): boolean {
    if (this.oldTerminal) {
      return !this.oldTerminal.serialNumber && !this.oldTerminal.deviceType;
    }
    return false;
  }

  public get isEditMode(): boolean {
    if (this.terminalsService) {
      return this.terminalsService.isEditMode;
    }
    return false;
  }

  public get anyShopAvailable(): boolean {
    return this.allShops && this.allShops.length > 0;
  }

  public get showError(): boolean {
    return this.terminalsService.showErrors;
  }

  public compareFn(obj1: Shop, obj2: Shop) {
    return obj1 && obj2 ? obj1.id === obj2.id : obj1 === obj2;
  }

  public trackByFn(index, item) {
    return index; // or item.id
  }

}
